import './FormElement.scss';
import Component from './FormElement.js';
export default Component;
